/*
 * @Desc: 部门管理 接口
 * @Author: may.li
 * @Date: 2023-05-21 10:24:59
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-05-30 14:08:54
 */
import request from "@/utils/request";
const index = {
  // 广告位管理
  // 列表
  list(query) {
    return request({
      url: "/section/list",
      method: "get",
      params: query
    });
  },
  // 新增
  create(data) {
    return request({
      url: "/section/create",
      method: "post",
      data
    });
  },
  // 编辑
  edit(data) {
    return request({
      url: "/section/edit",
      method: "post",
      data
    });
  },
  // 详情
  detail(query) {
    return request({
      url: "/section/detail",
      method: "post",
      params: query
    });
  },
  // 修改状态
  status(data) {
    return request({
      url: "/section/status",
      method: "post",
      data
    });
  },
  // 删除
  remove(data) {
    return request({
      url: "/section/remove",
      method: "post",
      data
    });
  },
  // 下拉选
  select(query) {
    return request({
      url: "/section/select",
      method: "get",
      params: query
    });
  },
};
export default index;